export const CopyCustomFieldApi = Symbol.for('CopyCustomFieldApi');
